import { render, staticRenderFns } from "./Se_Materials_and_Finishes.vue?vue&type=template&id=2a21882c&scoped=true"
import script from "./Se_Materials_and_Finishes.vue?vue&type=script&setup=true&lang=js"
export * from "./Se_Materials_and_Finishes.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Se_Materials_and_Finishes.vue?vue&type=style&index=0&id=2a21882c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a21882c",
  null
  
)

export default component.exports